<template>
  <el-dialog title="确认删除角色" :visible.sync="currentValue" width="auto" class="dialog-center">
    <div class="role-user">
      <el-alert title="角色中包含了以下用户，请解除绑定后删除！" type="warning"></el-alert>
      <el-table :data="tableData.users" style="width:800px;margin-top:20px;">
        <el-table-column prop="realname" label="姓名" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="job_title" label="职位" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="job_number" label="工号" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="phone" label="电话" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <el-button type="primary" size="mini" @click="removeRole">解除绑定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import api from '@/services/api/role/role'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  created() {
  },
  methods: {
    async removeRole() {
      let params = {
        role_name: this.tableData.role_name,
        uids: this.tableData.users.map(res => res.uid)
      }
      try {
        await api.removeUsersForRole(params)
        // this.$message({ type: 'success', message: '删除角色成功!' });
        this.$emit('complete')
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="scss">
.role-user {
  .el-table__row {
    td {
      padding: 10px 0;
      font-size: 12px;
    }
  }
}
</style>
